export default __webpack_public_path__ + "static/media/image15.45d8f05e.jpg";